import moment from 'moment';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
    setAmountError,
    setEndDateError,
    setNameError,
    setStartDateError,
    setTypeError,
} from '../../../features/createBudget/createBudgetSlice';

export const useBudgetValidation = () => {
    const dispatch = useDispatch();

    const validateAmount = useCallback((amount) => {
        if (!amount) {
            dispatch(setAmountError('Please provide a budget amount'));
            return false;
        } else if (amount.toString().length > 8) {
            dispatch(
                setAmountError('Please provide a budget amount less than 8 digits'),
            );
            return false;
        }
        return true;
    }, [dispatch]);

    const validateName = useCallback((name) => {
        if (!name) {
            dispatch(setNameError('Please provide a budget name'));
            return false;
        }
        return true;
    }, [dispatch]);

    const validateCustomBudgetFields = useCallback((start_date, end_date, type) => {
        let isValid = true;

        if (!start_date) {
            dispatch(setStartDateError('Please select a valid date'));
            isValid = false;
        }
        if (!end_date) {
            dispatch(setEndDateError('Please select a valid date'));
            isValid = false;
        }
        if (!type) {
            dispatch(setTypeError('Please select the budget type'));
            isValid = false;
        }

        return isValid;
    }, [dispatch]);

    const validateDateRange = useCallback((start_date, end_date) => {
        const daysDifferent = moment(end_date).diff(moment(start_date), 'days');
        if (daysDifferent < 2) {
            dispatch(setStartDateError('Date range must be at least 2 days apart'));
            dispatch(setEndDateError('Date range must be at least 2 days apart'));
            return false;
        }
        return true;
    }, [dispatch]);

    const validateForm = useCallback((formData, tab) => {
        const { amount, name, start_date, end_date, type } = formData;

        const isValidAmount = validateAmount(amount);
        const isValidName = validateName(name);
        if (tab === 'monthly' || tab === 'weekly') {
            return isValidAmount && isValidName;
        }

        if (tab === 'custom') {
            const basicValidation = isValidAmount && isValidName;
            const customValidation = validateCustomBudgetFields(start_date, end_date, type);
            const dateRangeValidation = validateDateRange(start_date, end_date);

            return basicValidation && customValidation && dateRangeValidation;
        }

        return false;
    }, [validateAmount, validateName, validateCustomBudgetFields, validateDateRange]);

    return {
        validateAmount,
        validateName,
        validateCustomBudgetFields,
        validateDateRange,
        validateForm,
    };
};